import { useState, MouseEvent } from 'react';
import { ReactComponent as CopyIcon } from '../../assets/Icons/adornments/Copy.svg';
import { Tooltip } from '@mui/material';

export default function CopyToClipbardButton({
    copyValue,
}: {
    copyValue: string,
}) {
    const [ open, setOpen ] = useState(false);

    const showTooltip = async () => {
        setOpen(true);

        setTimeout(() => {
            setOpen(false);
        }, 2000);
    }

    const copyToClipboard = (e:MouseEvent<HTMLButtonElement>) => {
            e.preventDefault();
            if (copyValue) {
                if (!navigator.clipboard) {
                    // Clipboard API not available, fallback method
                    fallbackCopyToClipboard(copyValue);
                    return;
                }
                navigator.clipboard.writeText(copyValue).then(function() {
                    showTooltip();
                }, function(err) {
                    console.error('Could not copy text: ', err);
                });
            }
            
        }
        
        function fallbackCopyToClipboard(text: string) {
            var textArea = document.createElement("textarea");
            textArea.value = text;
            // Avoid scrolling to bottom
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";
        
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
        
            try {
                var successful = document.execCommand('copy');
                var msg = successful ? 'successful' : 'unsuccessful';
                console.log('Fallback: Copying text command was ' + msg);
                showTooltip();
            } catch (err) {
                console.error('Fallback: Oops, unable to copy', err);
            }
        
            document.body.removeChild(textArea);
        }

    return (
        <Tooltip 
            title='Copied' 
            placement='top' 
            open={open}
            slotProps={{
                popper: {
                  modifiers: [
                    {
                      name: 'offset',
                      options: {
                        offset: [0, -8],
                      },
                    },
                  ],
                },
              }}
        >
            <button onClick={copyToClipboard} className='w-[14px] text-disable hover:text-primary transition-all'><CopyIcon/></button>
        </Tooltip>
    )
}